import type { BuildingUsersTranslations } from "../../types/buildingUsers";

export const buildingUsers: BuildingUsersTranslations = {
  subtitle: "Manage your building team contacts. Add team members, contractors, and stakeholders.",
  addContact: "Add Contact",
  searchPlaceholder: "Search by name, email, phone, or company...",
  filterByCompany: "Filter by company",
  allCompanies: "All Companies",
  contactsCount: "{count} contacts",
  companiesCount: "{count} companies",
  loading: "Loading team...",
  name: "Name",
  contact: "Contact",
  company: "Company",
  actions: "Actions",
  removeTitle: "Remove Contact",
  removeConfirm:
    "Are you sure you want to remove {name} from the team? This action cannot be undone.",
  removeContact: "Remove Contact",
  contactRemoved: "Contact removed",
  contactRemovedDesc: "Contact has been removed from the team.",
  removeFailed: "Failed to remove contact. Please try again.",
  loadError: "Failed to load team",
  noContacts: "No contacts found",
  noContactsSearch: "Try adjusting your search or filter criteria.",
  noContactsEmpty: "No team members have been added yet. Add contacts to get started.",
};
